import React from 'react';

// The light "card" look used by the sign-in page, shared by the other
// logged-out account pages (forgot password, reset password).
export const authCardStyles: { [key: string]: React.CSSProperties } = {
    container: {
        fontFamily: "'DM Sans', sans-serif",
        backgroundColor: "#F8F9FA",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
    },
    card: {
        background: "#FFFFFF",
        borderRadius: "16px",
        padding: "40px",
        width: "100%",
        maxWidth: "480px",
        border: "1px solid #E0E0E0",
        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.05)",
        textAlign: "center",
    },
    backArrow: {
        position: "absolute",
        left: "0",
        top: "4px",
        color: "#555555",
        fontSize: "24px",
        cursor: "pointer",
    },
    header: {
        position: "relative",
    },
    logoChip: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#0065FF",
        borderRadius: "10px",
        padding: "10px 18px",
        marginBottom: "24px",
        cursor: "pointer",
    },
    logo: {
        height: "28px",
    },
    title: {
        fontFamily: "'Urbanist', sans-serif",
        fontWeight: 700,
        fontSize: "28px",
        lineHeight: 1.2,
        marginBottom: "8px",
        color: "#141414",
    },
    subtitle: {
        fontSize: "16px",
        color: "#555555",
        marginBottom: "32px",
    },
    formGroup: {
        marginBottom: "20px",
        position: "relative",
        textAlign: "left",
    },
    label: {
        display: 'block',
        fontWeight: 500,
        fontSize: '14px',
        color: '#242424',
        marginBottom: '8px',
    },
    input: {
        width: "100%",
        padding: "12px 45px 12px 16px",
        backgroundColor: "#F8F9FA",
        border: "1px solid #D1D1D1",
        borderRadius: "8px",
        color: "#242424",
        fontSize: "16px",
        outline: "none",
        transition: "border-color 0.3s ease, box-shadow 0.3s ease",
    },
    inputError: {
        borderColor: "#dc3545",
    },
    inputIcon: {
        position: "absolute",
        right: "15px",
        top: "42px",
        cursor: "pointer",
    },
    hintList: {
        listStyle: "none",
        padding: 0,
        margin: "-8px 0 24px",
        textAlign: "left",
        fontSize: "14px",
    },
    hintNeutral: { color: "#555555" },
    hintOk: { color: "#1E8E3E" },
    hintBad: { color: "#dc3545" },
    button: {
        background: "#0065FF",
        borderRadius: "8px",
        border: "none",
        boxShadow: "0px 10px 20px -10px rgba(0, 101, 255, 0.4)",
        padding: "16px",
        fontFamily: "'DM Sans', sans-serif",
        fontWeight: 700,
        fontSize: "16px",
        color: "#FFFFFF",
        cursor: "pointer",
        width: "100%",
        transition: "all 0.3s ease",
    },
    buttonDisabled: {
        opacity: 0.6,
        cursor: "not-allowed",
    },
    footerText: {
        marginTop: "24px",
        fontSize: "14px",
        color: "#555555"
    },
    footerLink: {
        color: "#0065FF",
        fontWeight: 700,
        textDecoration: "none",
        background: "none",
        border: "none",
        padding: 0,
        cursor: "pointer",
        fontSize: "14px",
    },
};
